module.exports = __webpack_public_path__ + "static/img/banner-mobile21.77bcbfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile21.jpg
// module id = abHr
// module chunks = 1